<template>
  <div
    v-if="isGravatarImage(spark.state.user.photo_url)"
    class="tw:size-[30px] tw:*:size-[20px] tw:text-center tw:rounded-full tw:border tw:shrink-0"
  >
    <i class="tw:i-fas-user tw:text-gray-400" />
  </div>
  <MessageAvatar
    v-else
    :display-name="spark.state.user.name"
    :image-url="spark.state.user.photo_url"
  />
</template>

<script setup>
import { MessageAvatar } from '@/components/common/message/index.js'
import { isGravatarImage } from '@/utils.js'
</script>
